import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatUnknownUnit } from '@/common/utils/unFormatters'
import { EstablishmentRequiredDocumentValidationSchema } from '@/features/maintenance/establishmentRequiredDocuments/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateEstablishmentRequiredDocumentProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCreateEstablishmentRequiredDocument = ({
  onSuccess,
  onError,
}: UseCreateEstablishmentRequiredDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentRequiredDocument'],
    mutationFn: async ({ form }: { form: EstablishmentRequiredDocumentValidationSchema }) => {
      const required_document = {
        display_name: form.display_name,
        default_validity_in_days:
          form.has_default_validity_in_days && form.default_validity_in_days
            ? unFormatUnknownUnit(form.default_validity_in_days)
            : '',
        file_sample: form.file_sample || undefined,
      }

      return privateAxios.postForm('/maintenance/establishment_required_documents', { required_document })
    },
    onSuccess,
    onError,
  })
}
